const { validateUniqueField } = require('../services/front/validateUniqueField');
const { isEmpty } = require('../helpers/index');

/**
 *
 * @param {*} fieldValue
 * @param {object} validation validation object
 * @param {*} validation.value if can call the api
 * @param {string} validation.message message of error
 * @param {object} options object of options
 * @param {*} options.fieldName field name
 * @param {*} options.fieldType type of the current field
 * @param {*} options.globalModel
 * @param {*} options.gridBulk
 * @param {*} options.holder
 * @param {string} options.mode current mode (insert or update)
 * @param {*} options.objectType
 * @param {*} options.pk
 * @param {*} options.pkObjectType
 * @param {*} options.token
 * @returns {(string|undefined)} `validation.message` or `undefined`
 */
const uniqueFront = async (fieldValue, validation, options) => {
  const {
    fieldName,
    fieldType,
    globalModel,
    gridBulk,
    holder,
    mode,
    objectType,
    pk,
    pkObjectType,
    token,
  } = options;
  const { value, message, func } = validation;
  if (value && !isEmpty(fieldValue) && gridBulk !== true) {
    try {
      const response = await validateUniqueField(
        fieldName,
        {
          fieldType,
          fieldValue,
          func,
          globalModel,
          mode,
          objectType,
          pk,
          pkObjectType,
          holder,
        },
        token
      );
      const values = await response.data;
      return values?.canUse === false ? message : undefined;
    } catch (error) {
      // TODO: no se muestran errores de red o exceptions, se podria mandar con un alertc
      // console.log(error);
      return undefined;
    }
  }
  return undefined;
};

module.exports = {
  uniqueFront,
};
